<template>
  <div class="relative safe-area-top header-safe-area">
    <header
      class="border-b-[1.5px] border-primary-purple-100 bg-primary-white sm:h-[88px] h-[72px] lg:h-[100px] relative overflow-hidden"
    >
      <div
        class="absolute rounded-full xl:left-[171px] lg:w-[473px] lg:left-[11px] md:w-[341px] md:bottom-[-70px] md:left-4.5 h-[376px] w-[248px] bottom-[-9px] left-2 orange-circle"
      ></div>
      <div
        class="absolute rounded-full xl:bottom-[-168px] xl:right-[-130px] lg:h-[460px] lg:bottom-[-95px] lg:right-[-205px] md:h-[312px] md:bottom-[-79px] md:right-[-159px] h-[312px] w-[458px] md:w-[634px] lg:w-[784px] bottom-[-34px] right-[-210px] purple-circle"
      ></div>
    </header>
    <nav
      class="absolute top-0 flex justify-between ml-4 w-[93%] md:w-[96%] lg:w-[97%] z-[11] h-full items-center"
    >
      <div class="flex z-[1] gap-1 xm:gap-2.5 items-center">
        <div
          v-if="!isLeftBarHiddenForCurrentRoute"
          class="transform rtl:rotate-180 w-10 h-10 bg-white border border-primary-purple-100 hidden md:flex justify-center items-center cursor-pointer rounded-lg self-end"
          @click="mobileLeftBar"
        >
          <icon :icon="leftBarToggleIcon" />
        </div>
        <div class="w-10 h-10 md:hidden">
          <div
            v-if="!isLeftBarHiddenForCurrentRoute"
            class="flex transform rounded-[9px] bg-primary-purple-100 mr-0.5 justify-center items-center cursor-pointer w-10 h-10"
            @click="$emit('mobileLeftBar')"
          >
            <icon icon="bars" />
          </div>
          <teleport to="body">
            <UnReadNotificatonPopup
              :show-model="showNotificationPopupForUnread"
              @handleClick="hideNotificationPopupl"
            />
          </teleport>
        </div>
        <CampusesDropdown
          v-if="isCampusDropdownHidden && routerLevel.isCampusLevel && isMultipleCampusesAllowed"
          ref="campusComponent"
          class="w-28 xs:w-32 xsm:w-40 sm:w-40 lg:w-52"
          :class="[tabLeftNav ? 'md:w-36' : 'md:w-48']"
        />
        <ClassDropdown
          v-if="routerLevel.isClassLevel"
          ref="classComponent"
          class="w-28 xs:w-32 xsm:w-40 sm:w-40 lg:w-52"
          :class="[tabLeftNav ? 'md:w-36' : 'md:w-48']"
        />
        <SectionDropdown
          v-if="routerLevel.isSectionLevel"
          ref="sectionComponent"
          :key="forceRerender"
          :is-position-top="isMobileView"
          :class="[
            tabLeftNav ? 'md:w-36' : 'md:w-48',
            isMultipleCampusesAllowed
              ? 'hidden sm:block sm:w-40 lg:w-52'
              : 'block w-28 xs:w-32 xsm:w-40 sm:w-40 lg:w-52',
          ]"
        />
        <!-- <UserRoleSwitch /> -->
      </div>
      <Notification />

      <teleport to="body">
        <UnReadNotificatonPopup
          :show-model="showNotificationPopupForUnread"
          @handleClick="hideNotificationPopupl"
        />
      </teleport>
    </nav>
  </div>
</template>

<script>
import icon from '@components/icons/icon.vue'
import CampusesDropdown from '@/src/modules/header/campusesDropdown.vue'
import Notification from '@src/modules/header/notification.vue'
import SectionDropdown from '@/src/router/layouts/left-bar/SectionDropdown.vue'
import ClassDropdown from '@src/router/layouts/left-bar/ClassDropdown.vue'
import debounce from 'lodash/debounce'
import { mapState, mapGetters } from 'vuex'
import UnReadNotificatonPopup from '@src/router/views/admin/modals/UnReadNotificationPopup.vue'
import { getTimeInMs } from '@utils/generalUtil.js'
import { leftBarHiddenForCurrentRoute } from '@/src/utils/layoutUtils.js'

export default {
  components: {
    CampusesDropdown,
    Notification,
    ClassDropdown,
    SectionDropdown,
    icon,
    UnReadNotificatonPopup,
  },
  props: {
    showRightBarIcon: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['mobileLeftBar'],
  data() {
    return {
      isShadow: false,
      showNotificationPopupForUnread: false,
      forceRerender: 0,
    }
  },
  computed: {
    ...mapState({
      tabLeftNav: (state) => state?.layout?.tabLeftNav,
      campusDropdownHiddenOnRoutes: (state) => state?.layout?.campusDropdownHiddenOnRoutes,
      unreadNotifiationCount: (state) => state?.notifications?.unreadNotifiationCount,
      currentSectionScope: (state) => state?.layout?.currentSectionScope,
      routerLevel: (state) => state?.layout?.routerLevel,
      isMobileView: (state) => state?.layout?.isMobileView,
    }),
    ...mapGetters('layout', ['isMultipleCampusesAllowed']),
    isCampusDropdownHidden() {
      return !this.$route.matched.some((route) =>
        this.campusDropdownHiddenOnRoutes.includes(route.name),
      )
    },
    isLeftBarHiddenForCurrentRoute() {
      return leftBarHiddenForCurrentRoute(this.$route.name)
    },
    leftBarToggleIcon() {
      return this.tabLeftNav ? 'doubleChevronLeft' : 'doubleChevronRight'
    },
  },
  watch: {
    unreadNotifiationCount(count) {
      if (count) this.shouldDisplayNotificationPopupIfDisable()
    },
    currentSectionScope() {
      this.forceRerender++
    },
  },
  /**
   * Created Hook
   * @description This hook calls the handleScroll function with the delay
   */
  // TODO: This function is not used anywhere
  created() {
    this.handleDebouncedScroll = debounce(this.handleScroll, 10)
    window.addEventListener('scroll', this.handleDebouncedScroll)
  },
  methods: {
    blinkCampusField() {
      if (this.$refs.campusComponent) {
        this.$refs.campusComponent.blinkCampusField()
      }
    },
    blinkClassField() {
      if (this.$refs.classComponent) {
        this.$refs.classComponent.blinkClassField()
      }
    },
    blinkSectionField() {
      if (this.$refs.sectionComponent) {
        this.$refs.sectionComponent.blinkSectionField()
      }
    },
    debounce,
    handleScroll(event) {
      this.isUserScrolling = window.scrollY > 0
      this.isShadow = !!this.isUserScrolling
    },
    mobileLeftBar() {
      this.$store.commit('layout/SET_TAB_LEFT_BAR')
    },
    async shouldDisplayNotificationPopupIfDisable() {
      const nextCheck = localStorage.getItem('notificationNextCheck')
      const now = Date.now()
      const twentyFourHours = getTimeInMs(24, 'h')

      if (nextCheck && now < parseInt(nextCheck)) return

      localStorage.setItem('notificationNextCheck', (now + twentyFourHours).toString())

      const permission = await window.Notification.requestPermission()
      if (permission !== 'granted') this.showNotificationPopupForUnread = true
    },

    hideNotificationPopupl() {
      this.showNotificationPopupForUnread = false
    },
  },
}
</script>

<style lang="scss" scoped>
.orange-circle {
  background-image: radial-gradient(
    ellipse,
    rgba(255, 222, 188, 0.95),
    rgba(255, 148, 33, 0),
    transparent 140%
  );
}
.purple-circle {
  background-image: radial-gradient(
    ellipse,
    rgba(198, 184, 234, 0.37),
    rgba(105, 65, 198, 0),
    transparent 147%
  );
}
@media screen and (max-width: 639px) {
  .icon {
    width: 25px;
    height: 29px;
  }
  .top-position {
    top: 72px;
  }
}
@media (max-width: 369px) {
  .top-position {
    top: 92px;
  }
}
@media screen and (min-width: 640px) {
  .icon {
    width: 30px;
    height: 34px;
  }
}
</style>
